import React from 'react';
import './styles/casesside.css';
import SEO from '../../components/SEO';
import Header from '../../components/header';
import Footer from '../../components/footer';
import ArtikelSektion from '../../components/artikelsektion';
import Testimonials from '../../components/testimonials';
import CTAKnap, { CTAIkoner } from '../../components/ctaknap';
import ShowCase from '../../components/showcase';

const CasesHero = () => {
  return (
    <section className="cases-hero">
      <div className="container">
        <div className="cases-hero-content">
          <div className="cases-hero-text">
            <div className="cases-hero-badge">
              <span>Portfolio & Cases</span>
            </div>
            <h1 className="cases-hero-title">
              Vores <span className="cases-hero-accent">kunders resultater</span> taler 
              for sig selv
            </h1>
            <p className="cases-hero-description">
              Vi kan tale længe om strategi og teknologi, men i sidste ende er det resultaterne, der tæller. Her kan I dykke ned i et udvalg af de løsninger, vi har udviklet i tæt samarbejde med vores kunder. Se hvilke udfordringer de stod overfor, og hvordan vi i fællesskab skabte en platform, der løftede deres forretning.
            </p>
            <div className="cases-hero-stats">
              <div className="cases-hero-stat">
                <div className="cases-hero-stat-number">100+</div>
                <div className="cases-hero-stat-label">Hjemmesider skabt</div>
              </div>
              <div className="cases-hero-stat">
                <div className="cases-hero-stat-number">4.8★</div>
                <div className="cases-hero-stat-label">Google rating</div>
              </div>
              <div className="cases-hero-stat">
                <div className="cases-hero-stat-number">2021</div>
                <div className="cases-hero-stat-label">Etableret</div>
              </div>
            </div>
            <div className="cases-hero-actions">
              <CTAKnap 
                variant="primary" 
                size="large"
                href="/tjenester"
                icon={<CTAIkoner.ArrowRight />}
              >
                Se vores tjenester
              </CTAKnap>
              <CTAKnap 
                variant="outline" 
                size="large"
                href="/kontakt"
                icon={<CTAIkoner.Phone />}
              >
                Få et tilbud
              </CTAKnap>
            </div>
          </div>
          <div className="cases-hero-visual">
            <div className="cases-hero-mockup">
              <div className="mockup-grid">
                <div className="mockup-item mockup-item-1">
                  <div className="mockup-browser">
                    <div className="browser-header">
                      <div className="browser-dots">
                        <span className="dot"></span>
                        <span className="dot"></span>
                        <span className="dot"></span>
                      </div>
                    </div>
                    <div className="browser-content">
                      <div className="content-placeholder"></div>
                    </div>
                  </div>
                </div>
                <div className="mockup-item mockup-item-2">
                  <div className="mockup-mobile">
                    <div className="mobile-screen">
                      <div className="mobile-content">
                        <div className="mobile-header"></div>
                        <div className="mobile-body"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mockup-item mockup-item-3">
                  <div className="mockup-tablet">
                    <div className="tablet-screen">
                      <div className="tablet-content"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const CasesShowcase = () => {
  // Import billeder direkte i stedet for require() for bedre performance
  const cases = [
    {
      id: 1,
      title: "Byggeriets Partner Platform",
      image: require('../../images/showcase/byggeriets-pc.webp'),
      description: "En moderne og professionel hjemmeside til Byggeriets Partner, der fungerer som digital platform for deres kursusaktiviteter og kvalitetssikringsydelser.",
      tags: ["Webdesign", "Kursusplatform", "Erhvervsløsning"],
      results: ["Digital kursusplatform", "Professionel online tilstedeværelse", "Struktureret indholdsformidling"]
    },
    {
      id: 2,
      title: "CBS AI Knowledge Hub",
      image: require('../../images/showcase/CBS-PC.webp'),
      description: "En professionel platform for CBS AI, der specialiserer sig i at afholde foredrag og dele de seneste udviklinger inden for kunstig intelligens.",
      tags: ["AI Platform", "Foredrag", "Vidensdeling"],
      results: ["Professionel AI-platform", "Struktureret indholdsformidling", "Stærk faglig troværdighed"]
    },
    {
      id: 3,
      title: "Gislinge Manøvrebane",
      image: require('../../images/showcase/gislinge-mobil.webp'),
      description: "En professionel hjemmeside til Gislinge Manøvrebane med fokus på mobiloptimering og brugervenlig navigation for alle enheder.",
      tags: ["Køreskole", "Mobile First", "Lokalvirksomhed"],
      results: ["Mobilvenlig platform", "Forbedret brugeroplevelse", "Professionel online tilstedeværelse"]
    },
    {
      id: 4,
      title: "Louise Munk",
      image: require('../../images/showcase/louise-mobil.webp'),
      description: "En professionel hjemmeside til psykolog Louise Munk med fokus på tillid, professionalisme og let tilgængelighed for hendes klienter.",
      tags: ["Psykolog", "Sundhed", "Professionel"],
      results: ["Professionel online tilstedeværelse", "Øget klienttillid", "Nem kontaktmulighed"]
    },
    {
      id: 5,
      title: "JBC Entreprenøren",
      image: require('../../images/showcase/jbc.webp'),
      description: "En robust og professionel hjemmeside til JBC Entreprenøren, der fremhæver deres ekspertise inden for byggeri og entreprenørarbejde.",
      tags: ["Entreprenør", "Byggeri", "Erhverv"],
      results: ["Stærk virksomhedsprofil", "Professionel troværdighed", "Tydelig serviceformidling"]
    },
    {
      id: 6,
      title: "Lyngby Psykologen",
      image: require('../../images/showcase/Lyngbypsykologen.webp'),
      description: "En tillidsfuld og tilgængelig hjemmeside til Lyngby Psykologen med fokus på at skabe tryghed og nem kontakt for klienter.",
      tags: ["Psykolog", "Lyngby", "Terapi"],
      results: ["Øget klienttillid", "Forbedret tilgængelighed", "Professionel online tilstedeværelse"]
    },
    {
      id: 7,
      title: "Psykolog Hagmund",
      image: require('../../images/showcase/psykologhagmund.webp'),
      description: "En personlig og professionel platform til psykolog Charlotte Hagmund, der skaber tillid og let adgang til psykologiske ydelser.",
      tags: ["Psykolog", "Personlig", "Terapi"],
      results: ["Stærk personlig branding", "Øget klientkontakt", "Tillidsfuld kommunikation"]
    },
    {
      id: 8,
      title: "Psykologisk Info",
      image: require('../../images/showcase/psykologiskinfo.webp'),
      description: "En professionel hjemmeside til psykolog Psykologisk Info med fokus på tryg kommunikation og let tilgængelighed for klienter.",
      tags: ["Psykolog", "Terapi", "Professionel"],
      results: ["Professionel online tilstedeværelse", "Øget klienttillid", "Tryg kommunikation"]
    },
    {
      id: 9,
      title: "Psykolog Kontakten",
      image: require('../../images/showcase/psykologkontakten.webp'),
      description: "En tilgængelig og tryg hjemmeside til Psykolog Kontakten med fokus på nem kontaktskabelse og professionel kommunikation.",
      tags: ["Psykolog", "Kontakt", "Tilgængelighed"],
      results: ["Nem kontaktskabelse", "Øget klienttillid", "Professionel kommunikation"]
    },
    {
      id: 10,
      title: "Psykudredning",
      image: require('../../images/showcase/psykudredning.webp'),
      description: "En specialiseret platform til Psykudredning, der formidler komplekse psykologiske udredninger på en forståelig og professionel måde.",
      tags: ["Udredning", "Specialiseret", "Psykologi"],
      results: ["Klar kommunikation", "Professionel troværdighed", "Struktureret informationsformidling"]
    },
    {
      id: 11,
      title: "Relationspsykologerne",
      image: require('../../images/showcase/relationspsykologerne.webp'),
      description: "En varm og professionel hjemmeside til Relationspsykologerne med fokus på tillid og let tilgængelighed for klienter.",
      tags: ["Psykolog", "Professionel", "Terapi"],
      results: ["Professionel online tilstedeværelse", "Øget klienttillid", "Varm og tryg kommunikation"]
    },
    {
      id: 12,
      title: "Sejr Klimateknik",
      image: require('../../images/showcase/Sejrklimateknik.webp'),
      description: "En teknisk og professionel hjemmeside til Sejr Klimateknik, der fremhæver deres ekspertise inden for klima- og ventilationsløsninger.",
      tags: ["Klimateknik", "Ventilation", "Teknisk"],
      results: ["Teknisk troværdighed", "Professionel præsentation", "Klar serviceformidling"]
    }
  ];

  return (
    <section id="cases-showcase" className="cases-showcase-section">
      <div className="container">
        <div className="cases-showcase-header">
          <h2 className="cases-showcase-title">Vores seneste projekter</h2>
          <p className="cases-showcase-description">
            Se udvalgte eksempler på vores arbejde og hvordan vi har hjulpet 
            virksomheder med at opnå deres digitale mål
          </p>
        </div>
        
        <div className="cases-premium-grid">
          {cases.map((caseItem, index) => (
            <div key={caseItem.id} className={`case-premium-item case-item-${index + 1}`}>
              <div className="case-image-container">
                <img 
                  src={caseItem.image} 
                  alt={caseItem.title}
                  loading="lazy"
                  decoding="async"
                  className="case-image"
                  style={{ transform: 'translateZ(0)' }}
                />
              </div>
              <div className="case-content">
                <h3 className="case-title">{caseItem.title}</h3>
                <p className="case-description">{caseItem.description}</p>
                <div className="case-tags">
                  {caseItem.tags.map((tag, tagIndex) => (
                    <span key={tagIndex} className="case-tag">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="cases-cta-section">
          <div className="cases-cta-content">
            <h3>Klar til at skabe dit næste projekt?</h3>
            <p>Lad os hjælpe dig med at opnå lignende resultater</p>
            <div className="cases-cta-actions">
              <CTAKnap 
                variant="primary" 
                size="large"
                href="/kontakt"
                icon={<CTAIkoner.ArrowRight />}
              >
                Start dit projekt
              </CTAKnap>
              <CTAKnap 
                variant="outline" 
                size="large"
                href="/priser"
                icon={<CTAIkoner.BarChart />}
              >
                Se priser
              </CTAKnap>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const CasesSide = () => {
  return (
    <div className="cases-side">
      <SEO 
        title="Cases & Kundesucces | Se Vores Arbejde | Parla Branding"
        description="Se konkrete eksempler på, hvordan vi har hjulpet virksomheder med at omdanne deres online tilstedeværelse til en markant forretningsmæssig fordel."
        keywords="hjemmeside cases, webdesign portfolio, forretningsmæssig fordel, kundesucces eksempler, hjemmeside transformation, online tilstedeværelse"
        url="https://parlabranding.dk/cases"
        type="website"
        canonicalUrl="https://www.parlabranding.dk/cases"
      />
      
      <Header />
      
      <CasesHero />
      
      <CasesShowcase />
      
      <Testimonials 
        className="cases-testimonials"
        hideCasesButton={true}
        alternativeCasesButton={
          <CTAKnap 
            variant="primary" 
            size="large"
            href="/priser"
            icon={<CTAIkoner.ArrowRight />}
          >
            Se vores priser
          </CTAKnap>
        }
      />
      
      <ArtikelSektion />
      
      <Footer />
    </div>
  );
};

export default CasesSide;
